/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IFilterOption } from './FilterOption';

export interface IFilter {
  /** Название фильтра на английском **/
  name: EName;
  /** Название фильтра на русском(для вывода на клиент) **/
  displayName: string;
  /** Тип фильтра(чекбокс или радиобаттон) **/
  type: EType;
  /** Опции фильтра(варианты выбора) **/
  options: IFilterOption[];
}

export enum EName {
  /** Укажите тип ремонта? **/
  'RepairType' = 'repairType',
  /** Сколько лет ремонту? **/
  'RepairAge' = 'repairAge',
  /** Этаж **/
  'Floor' = 'floor',
  /** Подъезд **/
  'Entrance' = 'entrance',
  /** Удобства **/
  'Amenities' = 'amenities',
  /** Условия проживания **/
  'LivingConditions' = 'livingConditions',
  /** Кол-во этаже в доме **/
  'FloorCount' = 'floorCount',
  /** Год постройки **/
  'BuildYear' = 'buildYear',
  /** Где находится санузел **/
  'WcTypeLocation' = 'wcTypeLocation',
  /** Удобства(загородка) **/
  'SuburbanConvenience' = 'suburbanConvenience',
}
export enum EType {
  /** Чекбокс(квадратик), можно выбрать больше 1-го варианта **/
  'Checkbox' = 'checkbox',
  /** Радио баттон(кружочек), можно выбрать только 1 вариант **/
  'RadioButton' = 'radioButton',
}
